import { Button, Grid, Tooltip, Typography } from '@mui/material';
import {
  PURPLE_ICON_COLOR,
  RED_ICON_COLOR,
} from 'components/TeamOverview/CardsMenuSection/CardsMenuSection';
import { useOrdersTabContentStyles } from 'components/UserProfile/styles';
import { ApprovalDelegationIcon } from 'images/icons/ApprovalDelegationIcon';
import { DeleteIcon } from 'images/icons/DeleteIcon';
import React from 'react';

export const ChangeLogRow = ({ block }) => {
  const { classes } = useOrdersTabContentStyles();
  const {
    date,
    name,
    submission: { name: submissionName },
    organ: { name: organName },
    species: { name: speciesName },
    original_sample: { control_type: controlType, order_id: orderId },
    is_tumor: isTumor,
    projectName,
    action,
    [`${action}_request_user`]: { first_name: firstName, last_name: lastName },
  } = block;
  const user = `${firstName} ${lastName}`;
  const fullBlockName = `${projectName} ${name}`;
  const isNullTumor = isTumor === null && 'Unknown';
  const tumor = isNullTumor || (isTumor ? 'Positive' : 'Negative');

  const actionTypeButtons = {
    contribution: (
      <Button
        variant="outlined"
        className={[classes.actionButton, classes.contributeLabel].join(' ')}
        startIcon={<ApprovalDelegationIcon color={PURPLE_ICON_COLOR} />}
      >
        Contributed
      </Button>
    ),
    disposal: (
      <Button
        variant="outlined"
        startIcon={<DeleteIcon color={RED_ICON_COLOR} />}
        className={[classes.actionButton, classes.deleteLabel].join(' ')}
      >
        Disposed
      </Button>
    ),
  };

  return (
    <Grid container className={classes.orderRow}>
      <Grid item xs={0.75} className={classes.orderCell}>
        <Typography fontSize="0.875rem">{date}</Typography>
      </Grid>
      <Grid item xs={1.25} className={classes.orderCell}>
        <Typography fontSize="0.875rem">{actionTypeButtons[action]}</Typography>
      </Grid>
      <Grid item xs={1.5} className={classes.orderCell}>
        <Tooltip title={user}>
          <Typography
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="0.875rem"
          >
            {user}
          </Typography>
        </Tooltip>
      </Grid>
      <Grid item xs={2.25} className={classes.orderCell}>
        <Tooltip title={fullBlockName}>
          <Typography
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="0.875rem"
            textTransform="uppercase"
          >
            {fullBlockName}
          </Typography>
        </Tooltip>
      </Grid>
      <Grid item xs={0.75} className={classes.orderCell}>
        <Typography fontSize="0.875rem">{orderId}</Typography>
      </Grid>
      <Grid item xs={2} className={classes.orderCell}>
        <Tooltip title={submissionName}>
          <Typography
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="0.875rem"
          >
            {submissionName}
          </Typography>
        </Tooltip>
      </Grid>
      <Grid item xs={0.75} className={classes.orderCell}>
        <Typography fontSize="0.875rem">{organName}</Typography>
      </Grid>
      <Grid item xs={0.75} className={classes.orderCell}>
        <Typography fontSize="0.875rem">{speciesName}</Typography>
      </Grid>
      <Grid item xs={0.75} className={classes.orderCell}>
        <Typography fontSize="0.875rem">{tumor}</Typography>
      </Grid>
      <Grid item xs={1} className={classes.orderCell}>
        <Typography fontSize="0.875rem">{controlType}</Typography>
      </Grid>
    </Grid>
  );
};
